import ProgressLine from './components/progress-line/index.vue'
import BrainLevel from './components/brain-level/index.vue'

export const ProgressLineChart = ProgressLine
export const BrainLevelChart = BrainLevel
